import type { KnowledgeResponse } from "entities/knowledge/types";
import type { ErrorMeta } from "types/redux";

export enum PublicationActionTypes {
  FETCH_FOR_TOPIC = "entities/PUBLICATION_FETCH_FOR_TOPIC",
  FETCH_FOR_TOPIC_SUCCESS = "entities/PUBLICATION_FETCH_FOR_TOPIC_SUCCESS",
  FETCH_FOR_TOPIC_FAILURE = "entities/PUBLICATION_FETCH_FOR_TOPIC_FAILURE",
}

export type PublicationFetchForTopicPayload = {
  fromTime?: number;
  id: string;
  language?: string;
  limit: number;
  offset: number;
  publication_type?: string;
  search?: string;
  secondaryTopicId?: string | undefined;
  toTime?: number;
};

export type PublicationFetchForTopicAction = {
  meta: { forceRefresh?: boolean };
  payload: PublicationFetchForTopicPayload;
  type: PublicationActionTypes.FETCH_FOR_TOPIC;
};

export type PublicationFetchForTopicSuccessAction = {
  meta: PublicationFetchForTopicPayload;
  payload: { data: KnowledgeResponse[]; topicId: string };
  type: PublicationActionTypes.FETCH_FOR_TOPIC_SUCCESS;
};

type PublicationFetchForTopicFailureMeta = ErrorMeta & { searchCriteria: PublicationFetchForTopicPayload };

export type PublicationFetchForTopicFailureAction = {
  meta: PublicationFetchForTopicFailureMeta;
  type: PublicationActionTypes.FETCH_FOR_TOPIC_FAILURE;
};

export type PublicationAction =
  | PublicationFetchForTopicAction
  | PublicationFetchForTopicSuccessAction
  | PublicationFetchForTopicFailureAction;
